module.exports = __webpack_public_path__ + "media/Loops 110 Drums.c8d9f165.wav";